// @ts-nocheck
import { PICS_URL } from "../api";

let img = "<img />";
const mainItemsFunction = (mainItems) => {
  document.title = mainItems.seo_title;
  document
    .querySelector('meta[name="description"]')
    .setAttribute("content", mainItems.seo_description);
  document
    .querySelector('meta[name="keywords"]')
    .setAttribute("content", mainItems.seo_keywords);
};

const deliveryFunction = (deliveryItems) => {
  for (let item of deliveryItems) {
    const cards = document.querySelectorAll(".delivery-card__item");
    let innerCardText = `<div style='text-align: center;'> ${item.text_1} ${item.text_2}</div>`;
    switch (item.title) {
      case "title":
        document
          .querySelector(".delivery-info")
          .querySelector(".subtitle").innerHTML = item.text_1;
        document
          .querySelector(".delivery-info")
          .querySelector(".title-descr").innerHTML = item.text_2;
        break;
      case "card_1":
        cards[0].innerHTML = img + innerCardText;
        cards[0].querySelector("img").src = PICS_URL + item.icon_1;
        cards[0].querySelector("img").classList.add("delivery-card-img");
        cards[0].querySelector("h3").classList.add("delivery-card__title");
        cards[0]
          .querySelectorAll("p")[0]
          .classList.add("delivery-card__subtitle");
        cards[0].querySelectorAll("p")[1].classList.add("delivery-card__free");
        break;
      case "card_2":
        cards[1].innerHTML = img + innerCardText;
        cards[1].querySelector("img").src = PICS_URL + item.icon_1;
        cards[1].querySelector("img").classList.add("delivery-card-img");
        cards[1].querySelector("h3").classList.add("delivery-card__title");
        cards[1]
          .querySelectorAll("p")[0]
          .classList.add("delivery-card__subtitle");
        cards[1].querySelectorAll("p")[1].classList.add("delivery-card__free");

        break;
      case "card_3":
        cards[2].innerHTML = img + innerCardText;
        cards[2].querySelector("img").src = PICS_URL + item.icon_1;
        cards[2].querySelector("img").classList.add("delivery-card-img");
        cards[2].querySelector("h3").classList.add("delivery-card__title");
        cards[2]
          .querySelectorAll("p")[0]
          .classList.add("delivery-card__subtitle");
        cards[2].querySelectorAll("p")[1].classList.add("delivery-card__free");
        break;
      case "card_4_gold":
        let goldWrap = item.text_1 + item.text_2;
        document.querySelector(".delivery-card__item-gold").innerHTML =
          goldWrap + img;
        document
          .querySelector(".delivery-card__item-gold")
          .querySelector("h3")
          .classList.add("delivery-gold__title");
        document
          .querySelector(".delivery-card__item-gold")
          .querySelector("p")
          .classList.add("delivery-gold-subtitle");
        document
          .querySelector(".delivery-card__item-gold")
          .querySelector("img")
          .classList.add("car-img");
        document
          .querySelector(".delivery-card__item-gold")
          .querySelector("img").src = PICS_URL + item.icon_1;
        break;
      default:
        break;
    }
  }
};

const deliveryRussiaFunction = (deliveryRussiaItems) => {
  document.querySelector(".delivery-regions").innerHTML =
    deliveryRussiaItems[0].text_1 + deliveryRussiaItems[0].text_2;
  document
    .querySelector(".delivery-regions")
    .querySelectorAll("p")[0]
    .classList.add("subtitle");
  document
    .querySelector(".delivery-regions")
    .querySelectorAll("p")[1]
    .classList.add("title-descr");
};

const selfExportFunction = (selfExportItems) => {
  // console.log(selfExportItems);
  for (let item of selfExportItems) {
    switch (item.title) {
      case "title":
        document.querySelector(".delivery-pickup").innerHTML =
          item.text_1 + item.text_2;
        document
          .querySelector(".delivery-pickup")
          .querySelectorAll("p")[0]
          .classList.add("subtitle");
        document
          .querySelector(".delivery-pickup")
          .querySelectorAll("p")[1]
          .classList.add("title-descr");

        break;
      case "adress":
        document.querySelector(".pickup-adress").innerHTML = img + item.text_1;
        document.querySelector(".pickup-adress").querySelector("img").src =
          PICS_URL + item.icon_1;
        document
          .querySelector(".pickup-adress")
          .querySelector("img")
          .classList.add("gps-img");
        document
          .querySelector(".pickup-adress")
          .querySelector("p")
          .classList.add("pickup-subtitle");
        break;
      case "hours":
        document.querySelector(".pickup-hours").innerHTML = img + item.text_1;
        document.querySelector(".pickup-hours").querySelector("img").src =
          PICS_URL + item.icon_1;
        document
          .querySelector(".pickup-hours")
          .querySelector("img")
          .classList.add("hour-img");
        document
          .querySelector(".pickup-hours")
          .querySelector("p")
          .classList.add("pickup-subtitle");
        break;
      case "card_1":
        document.querySelectorAll(".pickup-cards-image")[0].src =
          PICS_URL + item.icon_1;
        document.querySelectorAll(".pickup-cards__info")[0].innerHTML =
          item.text_1 + item.text_2;
        document
          .querySelectorAll(".pickup-cards__info")[0]
          .querySelectorAll("p")[0]
          .classList.add("cards-title");
        document
          .querySelectorAll(".pickup-cards__info")[0]
          .querySelectorAll("p")[1]
          .classList.add("cards-descr");
        break;
      case "card_2":
        document.querySelectorAll(".pickup-cards-image")[1].src =
          PICS_URL + item.icon_1;
        document.querySelectorAll(".pickup-cards__info")[1].innerHTML =
          item.text_1 + item.text_2;
        document
          .querySelectorAll(".pickup-cards__info")[1]
          .querySelectorAll("p")[0]
          .classList.add("cards-title");
        document
          .querySelectorAll(".pickup-cards__info")[1]
          .querySelectorAll("p")[1]
          .classList.add("cards-descr");
        break;
      default:
        break;
    }
  }
};
const paymentFunction = (paymentItems) => {
  // console.log(paymentItems);
  for (let item of paymentItems) {
    switch (item.title) {
      case "title":
        document.querySelector(".payment-heading-js").innerHTML =
          item.text_1 + item.text_2;
        document
          .querySelector(".payment-heading-js")
          .querySelector("h2")
          .classList.add("title");
        document
          .querySelector(".payment-heading-js")
          .querySelector("p")
          .classList.add("title-descr");
        break;
      case "card_1":
        document.querySelectorAll(".payment-cards-image")[0].src =
          PICS_URL + item.icon_1;
        document.querySelectorAll(".payment-cards__info")[0].innerHTML =
          item.text_1 + item.text_2;
        document
          .querySelectorAll(".payment-cards__info")[0]
          .querySelectorAll("p")[0]
          .classList.add("cards-title");
        document
          .querySelectorAll(".payment-cards__info")[0]
          .querySelectorAll("p")[1]
          .classList.add("payment-cards-descr");
        break;
      case "card_2":
        document.querySelectorAll(".payment-cards-image")[1].src =
          PICS_URL + item.icon_1;
        document.querySelectorAll(".payment-cards-image")[1].src =
          PICS_URL + item.icon_1;
        document.querySelectorAll(".payment-cards__info")[1].innerHTML =
          item.text_1 + item.text_2;
        document
          .querySelectorAll(".payment-cards__info")[1]
          .querySelectorAll("p")[0]
          .classList.add("cards-title");
        document
          .querySelectorAll(".payment-cards__info")[1]
          .querySelectorAll("p")[1]
          .classList.add("payment-cards-descr");
        break;
      case "card_3":
        document.querySelectorAll(".payment-cards-image")[2].src =
          PICS_URL + item.icon_1;
        document.querySelectorAll(".payment-cards-image")[2].src =
          PICS_URL + item.icon_1;
        document.querySelectorAll(".payment-cards__info")[2].innerHTML =
          item.text_1 + item.text_2;
        document
          .querySelectorAll(".payment-cards__info")[2]
          .querySelectorAll("p")[0]
          .classList.add("cards-title");
        document
          .querySelectorAll(".payment-cards__info")[2]
          .querySelectorAll("p")[1]
          .classList.add("payment-cards-descr");
        break;
      case "card_4":
        document.querySelectorAll(".payment-cards-image")[3].src =
          PICS_URL + item.icon_1;
        document.querySelectorAll(".payment-cards-image")[3].src =
          PICS_URL + item.icon_1;
        document.querySelectorAll(".payment-cards__info")[3].innerHTML =
          item.text_1 + item.text_2;
        document
          .querySelectorAll(".payment-cards__info")[3]
          .querySelectorAll("p")[0]
          .classList.add("cards-title");
        document
          .querySelectorAll(".payment-cards__info")[3]
          .querySelectorAll("p")[1]
          .classList.add("payment-cards-descr");
        break;
      case "card_5":
        document.querySelectorAll(".payment-cards-image")[4].src =
          PICS_URL + item.icon_1;
        document.querySelectorAll(".payment-cards-image")[4].src =
          PICS_URL + item.icon_1;
        document.querySelectorAll(".payment-cards__info")[4].innerHTML =
          item.text_1 + item.text_2;
        document
          .querySelectorAll(".payment-cards__info")[4]
          .querySelectorAll("p")[0]
          .classList.add("cards-title");
        document
          .querySelectorAll(".payment-cards__info")[4]
          .querySelectorAll("p")[1]
          .classList.add("payment-cards-descr");
        break;
      default:
        break;
    }
  }
};

export {
  paymentFunction,
  mainItemsFunction,
  selfExportFunction,
  deliveryFunction,
  deliveryRussiaFunction,
};
